'use strict';

const nvpsSelectedActivityIDs = new Set();

// Open NVPS Product Search Pop-up
export function openNvpsApiProductSearchPop(options){
    if (!options) {
        options = {};
    }

    if (!options.activityCodeID) {
        alert('Unable to continue as Activity Code ID not specified. Please try again.');
        return;
    }

    if (!options.activityDescription){
        alert('Unable to continue as Activity Code Description not specified. Please try again.');
        return;
    }

    var popTitle = 'NVPS validation for ' + options.activityDescription;

    if (!options.vpaNumber) {
        options.vpaNumber = '';
    }
    else
    {
        popTitle += ' (' + options.vpaNumber + ')';
    }

    const nvpsProductSearchURL = '/pages/pop/nvps/nvpsProductSearch.cfm?' + jQuery.param({
        'activityCodeID': options.activityCodeID,
        'activityDescription': options.activityDescription,
        'vpaNumber': options.vpaNumber,
    });

    popWin({
        title: popTitle,
        noAutoWidth: true,
        width: 700,
        popID: 'activityCodeNVPSValidationPop',
        modal: true,
        hideCloseButton: false,
        page: nvpsProductSearchURL,
        buttons: {
            'Cancel': function() {
                $(this).dialog('close');
            },
        },
    });
}

// Search for Product
// Puts html list into passed productsDiv
export function nvpsApiProductSearch(options, productsDiv) {
    if (!options.productDescription) {
        alert('Unable to continue as Product Description is not specified. Please try again.');
        return;
    }

    if (typeof options.allSpecies !== 'boolean') {
        options.allSpecies = false;
    }

    var listURL = '/pages/pop/nvps/nvpsProductsList.cfm?' + jQuery.param({
        productDescription: options.productDescription,
        allSpecies: options.allSpecies,
    });

    $.ajax({
        type: 'GET',
        url: listURL,
        dataType: 'html',
        cache: false,
        success: function (data) {
            productsDiv.html(data);
        },
        error: function () {
            alert('Unable to retrieve list of products. Please try again.');
        },
    });
};

export function setProductWithNVPSDetails(options){
    var $activityCodeDetailsForm = $('#form_settings_list_activity_code');

    if (!options.activityDescription || !options.vpaNumber || !options.activityCodeId) {
        // eslint-disable-next-line max-len
        alert('Unable to continue as Product Details are not specified. Please try again.');
        return;
    }

    var vpaNumberInput = $activityCodeDetailsForm.find("[name='vpaNumber']");
    vpaNumberInput.val(options.vpaNumber);

    if (options.withdrawalPeriod && options.withdrawalPeriod > 0)
    {
        var withdrawalTimeInput = $activityCodeDetailsForm.find("[name='withdrawalTime']");
        withdrawalTimeInput.val(options.withdrawalPeriod);
    }

    // Reset route and unit pickers
    populateCodePicker('routeOfAdmin', options.activityCodeId, 'R');
    populateCodePicker('quantityMeasurement', options.activityCodeId, 'U');
    populateCodePicker('withdrawalTimePeriod', options.activityCodeId, 'T');
    // Change button text
    $('.js-nvps-link-button').text('Unlink NVPS');
};

// Populate Activity Code route or unit picker with NVPS data
export function populateCodePicker(pickerID, activityCodeId, type) {

    // Clear existing picker
    $('#' + pickerID + ' option').each((i, option) => {
        if ($(option).val() == 'chooseone') {
            $('#' + pickerID).empty();
            $(option).remove();
            return false;
        }
    });

    var url = '/pages/pop/nvps/nvpsPopulateActivityCodePicker.cfm?' + jQuery.param({
        activityCodeId: activityCodeId,
        type: type,
    });

    $('#' + pickerID).load(
        url,
        {randomNum: gen_random()},
        () =>{},
    );
}

// Unlink NVPS validation for Activity Code
export function unlinkActivityCode(activityCodeId) {
    var unlinkURL = '/components/services/nvpsAPI.cfc?' + jQuery.param({
        method: 'unlinkActivityCodeWeb',
        activityCodeId: activityCodeId,
    });

    $.ajax({
        type: 'POST',
        url: unlinkURL,
        data: gen_random(),
        dataType: 'json',
        cache: false,
        success: function(data){
            if (!data.success){
                alert(data.message);
            }
        },
        error: function(){
            alert('An error occured while unlinking NVPS activity code. Please try again.');
        },
    });
}

export function getPractitioners({
    practitionersPickerID = '',
    practiceID = '',
    nvpsOnly = '',
    onSuccess,
    onComplete,
    dropdownSelector = '#' + practitionersPickerID,
} = {}) {

    if (!onSuccess || typeof onSuccess !== 'function') {
        onSuccess = function (result) {
            var $dropDownObj = $(dropdownSelector);

            // Clear existing picker
            $dropDownObj.empty();

            if (result.length < 1) {
                $dropDownObj.append('<option value=""></option>')
                    .attr('disabled','disabled');
            } else {
                $dropDownObj.append('<option value=""></option>')
                    .removeAttr('disabled');
            }

            result.forEach((element) => {
                $dropDownObj.append(
                    $('<option>', {
                        value: element.ID,
                        text: element.NAME,
                    }),
                );
            });

            if (typeof onComplete !== 'undefined') {
                onComplete();
            }
        };
    }

    var $dropDownObj = $(dropdownSelector);
    $dropDownObj.attr('disabled', 'disabled');
    ajaxGetFunction({
        component: 'activity_settings',
        function: 'getPractitionerDropDownWeb',
        urlParams: {
            'Practice_ID': practiceID,
            'nvpsOnly': nvpsOnly,
            'Active': true,
            'json': true,
        },
        onSuccess: onSuccess,
    });
}

export function refreshDropDownsForNVPS({
    routeOfAdminPickerID = '',
    medicineMeasurementPickerID = '',
    withdrawalTimePeriodPickerID = '',
    activityCodeID = null,
    routeOfAdmin = null,
    medicineMeasurementID = null,
    withdrawalTimePeriodID = null,
} = {}) {

    if (activityCodeID == null) {
        alert('Unable to continue as Activity Code ID not specified. Please try again.');
        return;
    }

    // Route of Admin picker
    $('#' + routeOfAdminPickerID + ' option').each((i, option) => {
        $('#' + routeOfAdminPickerID).empty();
        $(option).remove();
    });

    var url = '/pages/pop/nvps/nvpsPopulateActivityCodePicker.cfm?' + jQuery.param({
        activityCodeId: activityCodeID,
        type: 'R',
        route: routeOfAdmin,
    });

    $('#' + routeOfAdminPickerID).load(
        url,
        {randomNum: gen_random()},
        () =>{},
    );

    //Medicine Measurement picker
    $('#' + medicineMeasurementPickerID + ' option').each((i, option) => {
        $('#' + medicineMeasurementPickerID).empty();
        $(option).remove();
    });

    var url = '/pages/pop/nvps/nvpsPopulateActivityCodePicker.cfm?' + jQuery.param({
        activityCodeId: activityCodeID,
        type: 'U',
        unit: medicineMeasurementID,
    });

    $('#' + medicineMeasurementPickerID).load(
        url,
        {randomNum: gen_random()},
        () =>{},
    );

    // Withdrawal Time Period picker
    $('#' + withdrawalTimePeriodPickerID + ' option').each((i, option) => {
        $('#' + withdrawalTimePeriodPickerID).empty();
        $(option).remove();
    });

    var url = '/pages/pop/nvps/nvpsPopulateActivityCodePicker.cfm?' + jQuery.param({
        activityCodeId: activityCodeID,
        type: 'T',
        time: withdrawalTimePeriodID,
    });

    $('#' + withdrawalTimePeriodPickerID).load(
        url,
        {randomNum: gen_random()},
        () =>{},
    );
}

export function useSelectedNVPSProduct(productId, productName, activityCodeId, withdrawalPeriod)
{
    // Call CFC to get product details
    var setCodeURL = '/components/services/nvpsAPI.cfc?' + jQuery.param({
        method: 'setProductDetailsWeb',
        vpaNumber: productId,
        activityCodeId: activityCodeId,
    });

    $.ajax({
        type: 'GET',
        url: setCodeURL,
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        cache: false,
        success: function () {
            // Set product details before saving
            EQLAPP.NVPS.setProductWithNVPSDetails(
                {
                    vpaNumber: productId,
                    activityDescription: productName,
                    activityCodeId: activityCodeId,
                    withdrawalPeriod: withdrawalPeriod,
                },
            );

            // Close this window
            popWinClose('activityCodeNVPSValidationPop');
        },
        error: function () {
            alert('Unable to retrieve product details. Please try again.');
        },
    });
}

export function nvpsMedicineGrid(options){
    if (!options.selector){
        EQLAPP.STRIPE.showAlert({title: 'Alert', body: 'Grid Object Missing'});return false;
    };

    if (!options.form){
        EQLAPP.STRIPE.showAlert({title: 'Alert', body: 'Form Object Missing'});return false;
    };

    var $mainFormObj = $('#' + options.form);
    var $nvpsGrid = $(options.selector);
    var horseID = $mainFormObj.find('[name="horse_ID"]').val();
    var dateFrom = $mainFormObj.find('[name="DateFrom"]').val();
    var dateTo = $mainFormObj.find('[name="DateTo"]').val();
    var unconfirmedTransfers = $mainFormObj.find("[name='unconfirmedTransfer']").is(':checked');
    var confirmedTransfers = $mainFormObj.find("[name='confirmedTransfer']").is(':checked');
    var completeTransfers = $mainFormObj.find("[name='completedTransfer']").is(':checked');//.val();

    var medicationURL = '/components/medicine.cfc?' + jQuery.param({
        method: 'getMedicineInquiryDetailsGridWeb',
        horseID: horseID,
        dateFrom: dateFrom,
        dateTo: dateTo,
        activityType: '1',
        medicineOnly: true,
        nvpsInput: true,
        nvpsUnconfirmed: unconfirmedTransfers,
        nvpsConfirmed: confirmedTransfers,
        nvpsComplete: completeTransfers,
    });

    $nvpsGrid.jqGrid({

        url: medicationURL
        ,datatype: 'json'
        ,colNames: [
            'ID'
            ,'Date'
            ,'Horse'
            ,'Description'
            ,'VPA Number'
            ,'Batch'
            ,'Expiry'
            ,'Route'
            ,'Dosage'
            ,'Prepared'
            ,'Transferred'
            ,'Edit'
            ,'Status'
            ,
        ]
        ,colModel: [
            {name: 'ID', index: 'ID',
                width: 0, sorttype: 'int', hidden: true, editable: false},
            {name: 'Date' ,index: 'Date',
                width: 72 ,formatter: 'date' ,formatoptions: {
                    srcformat: 'Y-m-d',
                    newformat: jsDateFormatString},
                sorttype: 'Date',
            },
            {name: 'HorseName',index: 'HorseName',width: 140,sorttype: 'text'},
            {name: 'Description',index: 'Description',width: 136,sorttype: 'text'},
            {name: 'VPANumber',width: 150, align: 'center',sortable: false},
            {name: 'BatchNumber',width: 62, align: 'center',sortable: false},
            {name: 'BatchExpiry',width: 72, align: 'center',sortable: false,
                formatter: 'date' ,formatoptions: {
                    srcformat: 'Y-m-d',
                    newformat: jsDateFormatString}
                ,sorttype: 'Date',
            },
            {name: 'MedicineRoute',width: 74, align: 'center',sortable: false},
            {name: 'MedicineDosage',width: 122, align: 'center',sortable: false},
            {name: 'nvpsPrepared',width: 5,
                align: 'center', hidden: true,sortable: false, editable: false},
            {name: 'nvpsTransferred',width: 5,
                align: 'center', hidden: true,sortable: false, editable: false},
            {name: 'editNVPS',index: 'editNVPS',
                width: 45,sortable: false,align: 'center',classes: 'option edit',
                cellattr: function(rowId,val,rawObject,cm,rData){
                    if (rowId > 0){
                        if (rData.nvpsTransferred == 1){
                            return 'class=""';
                        } else {
                            return 'class="option edit"';
                        }
                    }
                },
            },
            {name: 'confirmButton',index: 'confirmButton',
                width: 80,sortable: false,align: 'center',classes: 'fixButton'},//classes: ''},
        ]
        ,rowNum: 10
        ,rowList: [10,20,30]
        ,autowidth: true
        ,height: '100%'
        ,pager: '#jqGridNVPSPager'
        ,sortname: 'ID'
        ,viewrecords: true
        ,sortorder: 'Date'
        ,multiselect: true
        ,gridComplete: function()
        {
            gridFix($nvpsGrid);
        },
        loadComplete: function(data){
            $nvpsGrid.find('.jq_button').button();
            //Checkbox on top which selects all
            $('#cb_jqGridNVPS').bind('click',() =>{
                enableNVPSExport();
            });

            const ids = $(this).jqGrid('getDataIDs');
            var l = ids.length, irow, icell, rowid;
            var columnModel = $(this).jqGrid('getGridParam', 'colModel');
            var columnModelLength = columnModel.length;

            for (irow = 0; irow < l; irow++) {
                rowid = ids[irow];
                // get data from some column "readStatus"
                var nvpsPrepared = $(this).jqGrid('getCell', rowid, 'nvpsPrepared');
                var nvpsTransferred = $(this).jqGrid('getCell', rowid, 'nvpsTransferred');

                // now you can set css on the row with some
                if (nvpsPrepared === '0') {
                    for (icell = 0; icell < columnModelLength - 1; icell++) {
                        $(this).jqGrid('setCell',
                            rowid,
                            columnModel[icell].name,
                            '',
                            'hasMissingItems');
                    }
                }

                if (nvpsTransferred === '1') {
                    for (icell = 0; icell < columnModelLength - 1; icell++) {
                        $(this).jqGrid('setCell',
                            rowid,
                            columnModel[icell].name,
                            '',
                            'nvpsExported');
                    }
                }
            }

            //Hide Checkboxes for rows with 'hasMissingItems', so that will be not selectable
            var cbs = $('tr.jqgrow.hasMissingItems > td > input.cbox');
            cbs.attr('class', 'hide');
            cbs.attr('style','display:none;');

            //Hide Checkboxes for rows/cells with 'nvpsExported', so that will be not selectable
            var cbs = $('tr.jqgrow > td.nvpsExported > input.cbox');
            cbs.attr('class', 'hide');
            cbs.attr('style','display:none;');

            $('.jq_button').button();

            for (const id of ids) {
                if (nvpsSelectedActivityIDs.has(id)) {
                    $(this).jqGrid('setSelection', id, false);
                }
            }

        },rowattr: function (rowData,currentObj,rowId) {
            var rowClass = '';
            if (rowData.nvpsPrepared == 0)
            {
                rowClass += ' hasMissingItems';
            }
            if (rowData.nvpsTransferred == 1)
            {
                rowClass += ' nvpsExported';
            }
            return {'class': rowClass};
        },
        onCellSelect: function(rowid,iCol,cellcontent,e){
            var cm = $(this).jqGrid('getGridParam', 'colModel');
            var colName = cm[iCol].name;

            var className = e.srcElement.className;
            var nvpsTransferred = $(this).jqGrid('getCell', rowid, 'nvpsTransferred');

            if (colName == 'editNVPS'){
                $(this).jqGrid('setSelection',rowid);
                if (rowid > 0 && nvpsTransferred == 0){

                    var popWinTitle = 'NVPS Activity Edit';

                    var activityParams = $.param({
                        stopChargeUpdate: true,
                        activityID: rowid,
                        onClose: 'EQLAPP.NVPS.nvpsEditSuccess',
                    });

                    var popURL = 'pages/daily_activity_input.cfm?type=vet&' + activityParams;
                    popWin({
                        popID: 'editNVPSActivityPopup'
                        ,title: popWinTitle
                        ,modal: true
                        ,noAutoWidth: true
                        ,width: 800
                        ,page: popURL,
                    });

                    return false;
                }
            } else if (colName == 'confirmButton'){
                $(this).jqGrid('setSelection',rowid);
                if (rowid > 0){
                    var popWinTitle = 'NVPS Confirmation';

                    var popURL = '/pages/pop/?' + jQuery.param({
                        module: 'nvps',
                        page: 'nvpsExportDetails',
                        activityID: rowid,
                    });

                    var popupButtons = '';

                    if (nvpsTransferred == 1){
                        var popupButtons = { 'Close': function() { $(this).dialog('close'); }};
                    }
                    else {
                        var popupButtons = {
                            'Save': function () {
                                saveForm('nvps_input_edit',false, (data) =>
                                {
                                    var data = jQuery.parseJSON(data);
                                    if (data.success == 'true'){
                                        popWinClose('confirmNVPSActivityPopup');
                                        $('#jqGridNVPS').trigger('reloadGrid');
                                    } else {
                                        alert(data.message);
                                    }
                                });
                            },
                        };
                    }

                    popWin({
                        title: popWinTitle,
                        noAutoWidth: true,
                        popID: 'confirmNVPSActivityPopup',
                        width: 800,
                        modal: true,
                        page: popURL,
                        buttons: popupButtons,
                    });

                    return false;
                }
            } else if ((className == 'hasMissingItems') || (className == 'nvpsExported')){
                $(this).jqGrid('setSelection',rowid);
                var cbs = $('tr.jqgrow.hasMissingItems > td > input.cbox');
                cbs.removeAttr('checked');
                return false;
            }

        },
        beforeSelectRow: function(rowid, e) {
            var cbsdis = $('tr#' + rowid + '.jqgrow > td > input.cbox:disabled',
                $nvpsGrid[0]);
            if (cbsdis.length === 0) {
                return true; // allow select the row
            } else {
                return false; // not allow select the row
            }
        }
        ,onSelectAll: function(aRowids,status) {
            var recordAllPages = $(this).jqGrid('getGridParam', 'records');
            var recordCurrentPage = $(this).jqGrid('getGridParam', 'reccount');
            if (status) {
                // uncheck/deselect "unconfirmed" rows
                var cbs = $('tr.jqgrow.hasMissingItems > td > input.cbox');
                cbs.removeAttr('checked');
                var rows = $('tr.jqgrow.hasMissingItems');
                var irow;
                for (irow = 0; irow < rows.length; irow++) {
                    var rowID = rows[irow].id;
                    $(this).jqGrid('setSelection',rowID);
                }
                // uncheck/deselect "transferred" rows
                var cbs = $('tr.jqgrow > td.nvpsExported > input.cbox');
                cbs.removeAttr('checked');
                var rows = $('tr.jqgrow.nvpsExported');
                var irow;
                for (irow = 0; irow < rows.length; irow++) {
                    var rowID = rows[irow].id;
                    $(this).jqGrid('setSelection',rowID);
                }

                if (recordAllPages >= recordCurrentPage)
                {
                    aRowids.forEach((item, index) => {
                        nvpsSelectedActivityIDs.add(item);
                    });
                }

                //modify the selarrrow parameter
                $(options.selector)[0].p.selarrrow = $nvpsGrid
                    .find('tr.jqgrow:has(td > input.cbox:checked)')
                    .map(function() { return this.id; }) // convert to set of ids
                    .get(); // convert to instance of Array

            }
            else
            {
                aRowids.forEach((item, index) => {
                    nvpsSelectedActivityIDs.delete(item);
                });
            }
            enableNVPSExport();
        },
        onSelectRow: function(id, isSelected) {

            if (isSelected) {
                nvpsSelectedActivityIDs.add(id);
            } else {
                nvpsSelectedActivityIDs.delete(id);
            }
            enableNVPSExport();
        },
    }).navGrid('#jqGridNVPSPager',{add: false,
        edit: false,
        del: false,
        search: false,
        refresh: true});
}

export function nvpsEditSuccess(){
    popWinClose('editNVPSActivityPopup');
    var $nvpsExportPage = $('#nvpsExportPageContainer');
    var formID = $nvpsExportPage.data('form-id');
    var $jqGridNVPSExport = $nvpsExportPage.find('#jqGridNVPS');
    EQLAPP.NVPS.nvpsMedicineReloadGrid({
        selector: $jqGridNVPSExport,
        form: formID,
    });
}

export function nvpsMedicineReloadGrid(options){
    if (!options.selector){
        EQLAPP.STRIPE.showAlert({title: 'Alert', body: 'Grid Object Missing'});return false;
    };

    if (!options.form){
        EQLAPP.STRIPE.showAlert({title: 'Alert', body: 'Form Object Missing'});return false;
    };

    var $mainFormObj = $('#' + options.form);
    var horseID = $mainFormObj.find('[name="horse_ID"]').val();
    var dateFrom = $mainFormObj.find('[name="DateFrom"]').val();
    var dateTo = $mainFormObj.find('[name="DateTo"]').val();

    var unconfirmedTransfers = $mainFormObj.find("[name='unconfirmedTransfer']").is(':checked');
    var confirmedTransfers = $mainFormObj.find("[name='confirmedTransfer']").is(':checked');
    var completeTransfers = $mainFormObj.find("[name='completedTransfer']").is(':checked');

    var medicationURL = '/components/medicine.cfc?' + jQuery.param({
        method: 'getMedicineInquiryDetailsGridWeb',
        horseID: horseID,
        dateFrom: dateFrom,
        dateTo: dateTo,
        activityType: '1',
        medicineOnly: true,
        nvpsInput: true,
        nvpsUnconfirmed: unconfirmedTransfers,
        nvpsConfirmed: confirmedTransfers,
        nvpsComplete: completeTransfers,
    });

    //Reload Grid using Search Criteria URL
    $(options.selector).jqGrid('setGridParam',{
        url: medicationURL,
        page: 1,
        datatype: 'json'}).trigger('reloadGrid');

}

export function getnvpsSelectedActivityIDs(){
    return nvpsSelectedActivityIDs;
}

export function resetnvpsSelectedActivityIDs(){
    nvpsSelectedActivityIDs.clear();
}

export function enableNVPSExport(){
    var $nvpsExportPageContainer = $('#nvpsExportPageContainer');
    //Get number of checked checkboxes (ex table header checkbox)

    $nvpsExportPageContainer
        .find('.js-export-nvps')
        .button(nvpsSelectedActivityIDs.size > 0 ? 'enable' : 'disable');

    $nvpsExportPageContainer.find('.js-export-nvps')
        .find('.iconText')
        .text('Transfer Selected (' + nvpsSelectedActivityIDs.size + ')  ');
}

export function nvpsTransferReviewGrid(options){
    var $nvpsGrid = $(options.selector);
    var dailyInputIDs = options.dailyInputIDs;

    var medicationURL = '/components/medicine.cfc?' + jQuery.param({
        method: 'getMedicineInquiryDetailsGridWeb',
        activityType: '1',
        medicineOnly: true,
        nvpsInput: true,
        nvpsUnconfirmed: false,
        nvpsConfirmed: true,
        nvpsComplete: true,
        dailyInputID: dailyInputIDs,
    });

    $nvpsGrid.jqGrid({

        url: medicationURL
        ,datatype: 'json'
        ,colNames: [
            'ID'
            ,'Date'
            ,'Horse'
            ,'Description'
            ,'Date Exported'
            ,'User'
            ,'Prescription ID'
            ,
        ]
        ,colModel: [
            {name: 'ID', index: 'ID',
                width: 0, sorttype: 'int', hidden: true, editable: false},
            {name: 'Date' ,index: 'Date',
                width: 72 ,formatter: 'date' ,formatoptions: {
                    srcformat: 'Y-m-d',
                    newformat: jsDateFormatString},
                sorttype: 'Date',
            },
            {name: 'HorseName',index: 'HorseName',width: 140,sorttype: 'text'},
            {name: 'Description',index: 'Description',width: 136,sorttype: 'text'},
            {name: 'DateExported',width: 72, align: 'center',sortable: false,
                formatter: 'date' ,formatoptions: {
                    srcformat: 'Y-m-d',
                    newformat: jsDateFormatString}
                ,sorttype: 'Date',
            },
            {name: 'ExportStaffID',width: 74, align: 'center',sortable: false},
            {name: 'PrescriptionID',width: 122, align: 'center',sortable: false},
        ]
        ,rowNum: 5
        ,autowidth: true
        ,height: '100%'
        ,pager: '#jqGridNVPSReviewPager'
        ,sortname: 'ID'
        ,viewrecords: true
        ,sortorder: 'Date'
        ,multiselect: false
        ,gridComplete: function()
        {
            gridFix($nvpsGrid);
        },
    }).navGrid('#jqGridNVPSReviewPager',{add: false,
        edit: false,
        del: false,
        search: false,
        refresh: false});
}
